// Should stay in sync with SurveyChartOption.cs
const SURVEY_CHART_TYPE = {
  BAR: 0,
  LINE: 1
};

export default SURVEY_CHART_TYPE;
